<template>
  <BackgroundImageComponent></BackgroundImageComponent>
  <div class="container mt-4 position-relative">
    <div class="card mb-4">
      <div class="card-body">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-center"
        >
          <h1 class="text-ruderclub-orange">Aufgaben</h1>
          <button
            class="d-flex btn btn-ruderclub-dark-green"
            @click="openModal"
          >
            <i class="material-symbols-outlined me-2">add</i>Neue Aufgabe
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-responsive table-striped">
            <thead>
              <tr>
                <th>Titel</th>
                <th>Beschreibung</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="task in aufgaben" :key="task.id">
                <th>{{ task.title }}</th>
                <td v-html="task.description"></td>
                <!-- Formatierte Beschreibung -->
                <td>
                  <div class="btn-group btn-group-sm" role="group">
                    <button
                      class="d-flex align-self-center btn btn-outline-primary"
                      @click="editTask(task)"
                    >
                      <span class="material-symbols-outlined me-2">edit</span
                      >Bearbeiten
                    </button>

                    <button
                      v-if="istAdmin"
                      class="d-flex align-self-center btn btn-outline-success"
                      @click="markAsDone(task)"
                    >
                      <span class="material-symbols-outlined me-2"
                        >check_box</span
                      >
                      Erledigt
                    </button>

                    <button
                      v-if="istAdmin"
                      class="d-flex align-self-center btn btn-outline-danger"
                      @click="deleteTask(task)"
                    >
                      <span class="material-symbols-outlined">delete</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal-Komponente für Aufgaben -->
    <AufgabenModalComponent
      v-if="showModal"
      :task="editingTask"
      @close="closeModal"
      @save="saveTask"
    />
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  addDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import AufgabenModalComponent from "@/components/Aufgaben/AufgabenModalComponent.vue";
import { firebaseAuth, firebaseDb } from "@/main";
import BackgroundImageComponent from "@/components/Shared/BackgroundImageComponent.vue";

export default {
  name: "AufgabenView",
  components: { BackgroundImageComponent, AufgabenModalComponent },
  data() {
    return {
      aufgaben: [],
      showModal: false,
      editingTask: null,
      istAdmin: false,
    };
  },
  created() {
    this.loadTasks();
    this.checkAdminStatus();
  },
  methods: {
    async loadTasks() {
      const db = getFirestore();
      const q = query(
        collection(db, "aufgaben"),
        where("erledigt", "==", false)
      );
      const querySnapshot = await getDocs(q);
      this.aufgaben = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    },
    async checkAdminStatus() {
      const userDocRef = doc(
        firebaseDb,
        "benutzer",
        firebaseAuth.currentUser.uid
      );
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        this.istAdmin = userDocSnap.data().istAdmin;
      }
    },
    openModal() {
      this.editingTask = null;
      this.showModal = true;
    },
    editTask(task) {
      this.editingTask = task;
      this.showModal = true;
    },
    async saveTask(taskData) {
      const db = getFirestore();
      if (taskData.id) {
        await updateDoc(doc(db, "aufgaben", taskData.id), {
          title: taskData.title,
          description: taskData.description,
        });
      } else {
        await addDoc(collection(db, "aufgaben"), {
          title: taskData.title,
          description: taskData.description,
          erledigt: false,
        });
      }
      this.closeModal();
      this.loadTasks();
    },
    async markAsDone(task) {
      if (!this.istAdmin) return;
      const db = getFirestore();
      await updateDoc(doc(db, "aufgaben", task.id), { erledigt: true });
      this.loadTasks();
    },
    async deleteTask(task) {
      if (!this.istAdmin) return;
      const db = getFirestore();
      await deleteDoc(doc(db, "aufgaben", task.id));
      this.loadTasks();
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
